import { render, staticRenderFns } from "./EditZoneWhiteDialog.vue?vue&type=template&id=2db4dbbc"
import script from "./EditZoneWhiteDialog.vue?vue&type=script&lang=js"
export * from "./EditZoneWhiteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports